export const locale = {
  lang: 'de',
  data: {
    'CONFIRMACION': {
      'FELICI':'¡GLÜCKWUNSCH, SIE HABEN DAS ENDE DES KONFIGURATIONSPROZESSES ERREICHT!',
      'INDICACION':'Damit Ihre Umfrage aktiv ist und zu den konfigurierten Terminen angewendet werden kann, müssen Sie auf die Schaltfläche "Umfrage aktivieren" klicken',
      'CONFIRMAR':'Umfrage aktivieren',
      'IND_CONFIRM_JP': 'Bevor mit der Aktivierung der Umfrage fortgefahren wird, ist es notwendig, die zuvor konfigurierten Informationen zu bestätigen',
      'BTN_CONFIRM_INFO': 'Bestätigen Sie die Informationen ',
      'IND_ESP_CONFIRM_JP':'Sobald der Projektleiter bestätigt, werden wir die Umfrage aktivieren',
      'MOD_TIT_CONGR_CONF':'Vielen Dank für Ihre Bestätigung',
      'MOD_ESP_CONFIRM_JP':'Wir brauchen nur die Zustimmung des Projektleiters, um mit der Aktivierung der Umfrage fortzufahren.',
      'CERRAR-CONFIRMAR':'Umfrage deaktivieren',
      'MESSAGE5':'Aktive Umfrage kann angewendet werden',
      'HISTORY_ACTIVATION_1':'Letzte Aktivierung/Deaktivierung',
      'HISTORY_ACTIVATION_2': 'Aktivierungshistorie:',
      'ESTATUS_SURVEY':{
        '0':'Deaktivierung',
        '1':'Aktivierung',
        '2':'Geschlossen',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>To continue the activation of the survey',
          // 'MESSAGE2':', enter the text in red in the text box</span>',
          'MESSAGE1':'<span> Um die Aktivierung der Umfrage fortzusetzen, geben Sie den rot markierten Text in das Textfeld ein: ',
          'MELDUNG2':'</span>',
          'SALIR': 'Abbrechen',
          'VALIDAR': 'Bestätigen',
          'ERRORNOMBREEMPRESA': 'der eingegebene Text stimmt nicht mit dem rot markierten Text überein',
          'SUCCES': 'Die Umfrage wurde aktiviert',
          'CERRAR': 'Schließen',
          'SUCCES-DES': 'Die Umfrage wurde deaktiviert',
          'MESSAGE3':'<span> Um die Deaktivierung der Umfrage fortzusetzen, geben Sie den rot markierten Text in das Textfeld ein: ',
          'MESSAGE4':'</span>',
          'MESSAGE5':'Derzeit hat die Umfrage bereits Ergebnisse, sind Sie sicher, dass Sie sie deaktivieren können?',
          'MESSAGE6':'Derzeit gibt es keine Umfrage',
          'BTN-ACEPTAR':'Akzeptieren',
          'BTN-CANCELAR': 'Abbrechen',
          'BTN-OK': 'Ok',
          'HORAMINIMA': 'Die Kommunikation per E-Mail konnte nicht bestätigt werden, das Datum der ersten zu versendenden E-Mail (Launch oder erste Benachrichtigung, je nach Fall) muss ab diesem Zeitpunkt später als zwei Stunden liegen \n\nGegebenenfalls die Daten neu festlegen'

        },
      },
      'MODAL_CONFIRMACION': {
        'TITULO': 'Bestätigung der Daten',
        'INFO_1': 'Wir weisen Sie darauf hin, dass Sie die Informationen Ihres Produkts bestätigen müssen, bevor Sie mit der Aktivierung der Umfrage fortfahren. Nachfolgend stellen wir Ihnen die Details Ihres Unternehmens und Produkts zur Verfügung',
        'INFO_2': 'Wenn die Informationen korrekt sind, klicken Sie auf die Schaltfläche <b>Bestätigen</b>, andernfalls wenden Sie sich für eine Überprüfung an Ihren Projektmanager',
        'TABLA': {
          'TITULOS': {
            'clave': 'Feldname',
            'valor': 'Aktueller Wert'
          },
          'CAMPOS': {
            'company_name': 'Name der Firma',
            'short_name': 'Kurzer Name',
            'publication_name': 'Name der Veröffentlichung',
            'company': 'Firmenlogo',
            'certificate': 'Zertifikat-Logo',
            'foundation_year': 'Gründungsjahr',
            'fullTime_employees': 'Anzahl der Vollzeitbeschäftigten',
            'parcial_employees': 'Anzahl der Teilzeitmitarbeiter',
            'total_employees': 'Totale Mitarbeiter',
            'sector': 'Sektor',
            'sub_sector': 'Untersektor',
            'rankig_type': 'Ranking-Typ',
            'ranking_name': 'Ranking-Name',
            'name_RH': 'Name des Personalleiters',
            'email_RH': 'E-Mail des Personalleiters',
            'tel_RH': 'Telefonnummer des Personalleiters',
            'ext_RH': 'HR-Manager-Erweiterung',
            'cel_RH': 'Handynummer des Personalleiters',
            'state': 'Zustand',
            'multinational_group': 'Name des multinationalen Konzerns',
            'country_application': 'Land der Anwendung',
          }
        }
      }
    },
  }
};
